import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "login-panel" }
const _hoisted_2 = { class: "user-info" }
const _hoisted_3 = { class: "user-name" }
const _hoisted_4 = { class: "role-name" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Log out")
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "Do you want to log out from the web portal?", -1)
const _hoisted_7 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")
  const _component_LogoutIcon = _resolveComponent("LogoutIcon")
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_dropdown, {
      class: "login-panel",
      trigger: "click"
    }, {
      dropdown: _withCtx(() => [
        _createVNode(_component_el_dropdown_menu, {
          style: { width: `${_ctx.state.dropdownWidth}px` }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_dropdown_item, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openLogoutPopup()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LogoutIcon),
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["style"])
      ]),
      default: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("span", _hoisted_3, _toDisplayString(_ctx.user.name), 1),
            _createVNode("span", _hoisted_4, _toDisplayString(_ctx.userRoleName), 1)
          ]),
          _createVNode(_component_ChevronDownIcon)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      title: "Log out",
      modelValue: _ctx.state.dialogVisible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.dialogVisible = $event)),
      top: "30vh",
      width: "40%"
    }, {
      footer: _withCtx(() => [
        _createVNode("span", _hoisted_7, [
          _createVNode("button", {
            class: "button secondary",
            style: {"margin-right":"16px"},
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.dialogVisible = false))
          }, " Cancel "),
          _createVNode("button", {
            class: "button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.logout()))
          }, " Log out ")
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}